import { Component } from '@angular/core';
import { Store } from '@ngxs/store';
import { NotificationBaseComponentDirective } from '../../modeles/notification-base-component';
import { ConfigurationService } from '@oel/js-configuration';

@Component({
  selector: 'app-preautorisation-notification',
  templateUrl: './preautorisation-notification.component.html',
  styleUrls: ['./preautorisation-notification.component.scss'],
  standalone: false
})
export class PreautorisationNotificationComponent extends NotificationBaseComponentDirective {
  private readonly CLE_CONFIG_STATIC_SPA_URL = 'oel-static-spa-url';

  constructor(_store: Store) {
    super(_store);
  }

  scrollToSection(): boolean {
    super.scrollToSection('sectionPreautorisation');

    return false;
  }

  closeNotification() {
    super.closeNotification();
  }

  obtenirUrlAbsolu(cheminRelatif: string): string {
    const urlBaseSpaStatique = ConfigurationService.getConfig(this.CLE_CONFIG_STATIC_SPA_URL);
    if (urlBaseSpaStatique) {
      const urlBaseNormalise = `${urlBaseSpaStatique}${!urlBaseSpaStatique.endsWith('/') ? '/' : ''}`;
      return new URL(cheminRelatif, urlBaseNormalise).href;
    }

    return cheminRelatif;
  }
}
